import { isEmpty } from 'lodash';

import { Translate } from '@dreryk/react-common';
import { Text, TextSeparator, TextSeparatorType, TextView } from '@dreryk/react-components';

import { visitSettlementTranslationKeys } from '../../../translations';

import { PractitionerFormBeanPart } from './visitDetails.types';

const t = visitSettlementTranslationKeys.shared.form.visitDetails.practitionerTextView;

type PractitionerTextViewProps = {
   readonly practitioner: PractitionerFormBeanPart;
};

export const PractitionerTextView = (props: PractitionerTextViewProps): JSX.Element => {
   return (
      <TextView testId={'practitioner'} label={t.label}>
         <TextSeparator separator={TextSeparatorType.SPACE}>
            <Text testId={'firstName'}>{props.practitioner.firstName}</Text>
            <Text testId={'lastName'}>{props.practitioner.lastName}</Text>
         </TextSeparator>
         {', '}
         <Text testId={'specialtyNames'}>
            {isEmpty(props.practitioner.specialtyNames) ? (
               <Translate>{t.noSpecialties}</Translate>
            ) : (
               props.practitioner.specialtyNames.join(', ')
            )}
         </Text>
      </TextView>
   );
};
